class Notification {
  constructor(type, title, message) {
    const notificaton = document.querySelector('#notificationizer');
    const ntfTitle = document.querySelector('#notificationizer').querySelector('.notificationizer-message').querySelector('.title');
    const ntfMessage = document.querySelector('#notificationizer').querySelector('.notificationizer-message').querySelector('.description');
    notificaton.classList.add('show');
    notificaton.classList.add(type);
    ntfTitle.innerHTML = title;
    ntfMessage.innerHTML = message;
    setTimeout(() => {
      notificaton.classList.remove('show');
      notificaton.classList.remove(type);
    }, 5000);
  }
}

export default Notification;
